// src/navigation/wrappers/PublicNavigationWrapper.jsx
import React from 'react';
import PublicNav from '../../components/PublicNav';
import PublicTopMenuBar from '../../components/PublicTopMenuBar';
import PublicMobileBottomNav from '../../components/PublicMobileBottomNav';
import PublicFooter from '../../components/PublicFooter';

const PublicNavigationWrapper = ({ children }) => {
  return (
    <>
      <PublicNav />
      <PublicTopMenuBar />
      {children}
      <PublicMobileBottomNav />
      <PublicFooter />
    </>
  );
};

export default PublicNavigationWrapper;
